<template>
  <SrpModal :isVisible="props.isVisible" @update:isVisible="isVisible => emit('update:isVisible', isVisible)" size="small">
    <template #content>
      <h1
        class="global-h1"
        :style="{
          opacity: isDeleting ? '0.5' : '1',
        }"
      >
        Delete "{{ props.itemTitle }}"?
      </h1>
    </template>

    <template #footer="{ closeModal }">
      <div style="gap: 12px; display: flex; align-items: center">
        <SrpButton color="gray" fill="outlined" @click="closeModal" :isDisabled="isDeleting">Cancel</SrpButton>

        <SrpButton
          color="red"
          @click="
            async () => {
              await handleDeletion();
              closeModal();
            }
          "
          :isDisabled="isDeleting"
        >
          <template #icon>
            <LoadingIcon v-if="isDeleting" />
            <IconEmbedded v-else name="trashcan-alt_2-5" :size="20" />
          </template>
          Delete
        </SrpButton>
      </div>
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import ContentCalendarRepo from "@repos/ContentCalendarRepo";

// Components
import SrpModal from "@components/ui/SrpModal.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import LoadingIcon from "@components/ui/LoadingIcon.vue";

const props = withDefaults(
  defineProps<{
    isVisible: boolean;
    customerId: string;
    itemId: string;
    itemTitle: string;
  }>(),
  {}
);

const emit = defineEmits<{
  (e: "update:isVisible", isVisible: boolean): void;
  (e: "delete"): void;
}>();

// Handle deletion ============================================================
const isDeleting = ref<boolean>(false);

async function handleDeletion() {
  isDeleting.value = true;
  await ContentCalendarRepo.deleteItem(props.customerId, props.itemId);
  isDeleting.value = false;

  emit("delete");
}
</script>
